import Button from '../components/Button';
import { redirectToSSO } from '../utils/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import '../styles/Logout.css';

function Logout() {
  return (
    <div className="logout-container" data-testid="logout-container">
      <div className="logout-card" data-testid="logout-card">
        <div className="logout-icon">
          <FontAwesomeIcon icon={faRightFromBracket} size="4x" color="#52B8FF" />
        </div>
        <h2 data-testid="logout-heading">You've Been Logged Out</h2>
        <p className="logout-message" data-testid="logout-message">
          Your session has ended successfully.
        </p>
        <Button type="button" onClick={redirectToSSO} size="lg" data-testid="logout-login-btn">
          Log Back In
        </Button>
      </div>
    </div>
  );
}

export default Logout;
